import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import SophisticatedTooltipContent from '../SophisticatedTooltipContent';
import s from './SophisticatedTooltipBase.scss';
/**
 * Provides the base or our implementation of the SophisticatedTooltip.
 *
 * This is separated out to make it easier to manage differing opening/closing logic between FTUEs and normal tooltips.
 */ const SophisticatedTooltipBase = (_param)=>{
    var { width , postfix , prefix , size , description , forceTheme , hasCloseButton , onClose , onReferenceClick , onReferenceMouseEnter , onReferenceMouseLeave , children , className , contentClassName  } = _param, rest = _object_without_properties(_param, [
        "width",
        "postfix",
        "prefix",
        "size",
        "description",
        "forceTheme",
        "hasCloseButton",
        "onClose",
        "onReferenceClick",
        "onReferenceMouseEnter",
        "onReferenceMouseLeave",
        "children",
        "className",
        "contentClassName"
    ]);
    const heading = rest.heading;
    const ariaLabel = rest['aria-label'];
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, _extends({
        className: c(s['root'], className),
        onReferenceClick: onReferenceClick,
        onReferenceMouseEnter: onReferenceMouseEnter,
        onReferenceMouseLeave: onReferenceMouseLeave,
        renderPopover: ({ effectivePlacement , effectiveSecondaryPlacement , rootRef , arrowRef , contentStyle , arrowStyle , contentAttributes , arrowAttributes , updatePositioning ,  })=>/*#__PURE__*/ React.createElement(SophisticatedTooltipContent, {
                width: width,
                heading: heading,
                "aria-label": ariaLabel,
                description: description,
                prefix: prefix,
                postfix: postfix,
                size: size,
                contentClassName: contentClassName,
                hasCloseButton: hasCloseButton,
                forceTheme: forceTheme,
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                arrowAttributes: arrowAttributes,
                arrowStyle: arrowStyle,
                contentStyle: contentStyle,
                contentAttributes: contentAttributes,
                updatePositioning: updatePositioning,
                onMouseEnter: onReferenceMouseEnter,
                onMouseLeave: onReferenceMouseLeave,
                onClose: onClose
            })
    }, rest), children);
};
SophisticatedTooltipBase.displayName = 'SophisticatedTooltipBase';
export default SophisticatedTooltipBase;
